import { render, staticRenderFns } from "./ContractComments.vue?vue&type=template&id=446b0e76&"
import script from "./ContractComments.vue?vue&type=script&lang=js&"
export * from "./ContractComments.vue?vue&type=script&lang=js&"
import style0 from "./ContractComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports